import { SafeSessionTypeFilterSchema } from '@/src/domains/therapist-filters/constants'

export const parseTherapistSessionTypeFilterValue = (value: unknown) => SafeSessionTypeFilterSchema.parse(value)
